import { css } from 'lit';

export const appButtonStyles = css`
  :host {
    display: inline-block;
  }

  .app-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    height: 100%;
    box-sizing: border-box;
    font-family: var(--font-sans, sans-serif);
    font-size: 0.88rem;
    font-weight: 500;
    line-height: 1;
    border-radius: 4px;
    cursor: pointer;
    border: 1px solid transparent;
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, transform 0.05s ease;
    text-decoration: none;
    outline: none;
    user-select: none;
  }

  .app-btn:active:not(.btn-disabled) {
    transform: scale(0.98);
  }

  /* Variants */
  .variant-primary {
    background: var(--accent-color, #245590);
    color: #ffffff;
    border-color: var(--accent-color, #245590);
  }

  .variant-primary:hover:not(.btn-disabled) {
    background: var(--accent-hover, #173760);
    border-color: var(--accent-hover, #173760);
  }

  .variant-secondary {
    background: var(--bg-secondary, #f6f6f2);
    color: var(--text-primary, #1a1a18);
    border-color: var(--border-color, #e5e5de);
  }

  .variant-secondary:hover:not(.btn-disabled) {
    background: var(--border-color, #e5e5de);
  }

  .variant-text {
    background: transparent;
    color: var(--accent-color, #245590);
    font-family: var(--font-mono, monospace);
    font-size: 0.85rem;
    padding: 0;
    border: none;
  }

  .variant-text:hover:not(.btn-disabled) {
    text-decoration: underline;
  }

  /* Sizes */
  .size-sm {
    padding: 0.35rem 0.65rem;
    font-size: 0.8rem;
  }

  .size-md {
    padding: 0.55rem 1.1rem;
    font-size: 0.88rem;
  }

  .size-lg {
    padding: 0.75rem 1.4rem;
    font-size: 0.95rem;
  }

  /* Disabled State */
  .btn-disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
